import { cn } from '~/shadcn/lib/utils';

function Skeleton({ className, ...props }) {
    return <div data-slot="skeleton" className={cn('bg-border animate-pulse rounded-md', className)} {...props} />;
}

export { Skeleton };
